<template>
  <div class="p-6">
    <formulate-form name="dataform" @submit="formHandler" class="grid gap-4">
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Nombre_es</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="text"
            name="Nombre_es"
            help="Nombre en español"
            class="md:w-7/12 w-full"
            v-model="men_name"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Nombre_en</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="text"
            name="Nombre_en"
            help="Nombre en ingles"
            class="md:w-7/12 w-full"
            v-model="men_name_en"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Nombre_pr</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="text"
            name="Nombre_pr"
            help="Nombre en portugues"
            class="md:w-7/12 w-full"
            v-model="men_name_pr"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Ruta</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="text"
            name="Ruta"
            help="Ejemplo: /menu"
            class="md:w-7/12 w-full"
            v-model="men_route"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Icono</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <v-select
            class="style-chooser md:w-7/12 w-full"
            :options="list_icons"
            v-model="men_icon"
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Orden</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="number"
            name="Orden"
            help="Ejemplo: 0-10"
            class="md:w-7/12 w-full"
            v-model="men_order"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Parent</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="number"
            name="Parent"
            class="md:w-7/12 w-full"
            help="Ejemplo: 0-10"
            v-model="men_parent"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/6">
          <span>Admin</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <vs-switch
            color="dark"
            icon-pack="feather"
            vs-icon-on="icon-check-circle"
            vs-icon-off="icon-slash"
            v-model="men_isadmin"
          >
            <span slot="on">Si</span>
            <span slot="off">No</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Estado</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <vs-switch
            color="dark"
            icon-pack="feather"
            vs-icon-on="icon-check-circle"
            vs-icon-off="icon-slash"
            v-model="men_status"
          >
            <span slot="on">Activo</span>
            <span slot="off">Inactivo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row flex justify-center">
        <div class="vx-col md:w-1/3 w-full grid grid-cols-2 gap-4">
          <vs-button
            color="#EE9436"
            icon-pack="feather"
            icon="icon-save"
            @click="saveform"
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            >Grabar</vs-button
          >
          <vs-button
            color="#EE9436"
            icon-pack="feather"
            icon="icon-arrow-left"
            @click="go_back"
            >Regresar</vs-button
          >
        </div>
      </div>
    </formulate-form>
  </div>
</template>

<script>
import icons from "./icons.js";
export default {
  name: "new",

  data() {
    return {
      list_icons: [],
    };
  },

  mounted() {
    this.list_icons = icons;
  },

  computed: {
    men_id: {
      get() {
        return this.$store.state.menu.menuId || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_id", val);
      },
    },
    men_order: {
      get() {
        return this.$store.state.menu.menuOrder || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_order", val);
      },
    },
    men_name: {
      get() {
        return this.$store.state.menu.menuNameSp || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_name", val);
      },
    },
    men_name_en: {
      get() {
        return this.$store.state.menu.menuNameEn || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_name_en", val);
      },
    },
    men_name_pr: {
      get() {
        return this.$store.state.menu.menuNamePr || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_name_pr", val);
      },
    },
    men_route: {
      get() {
        return this.$store.state.menu.menuRoute || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_route", val);
      },
    },
    men_param: {
      get() {
        return this.$store.state.menu.menuParam || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_param", val);
      },
    },
    men_icon: {
      get() {
        return this.$store.state.menu.menuIcon || null;
      },
      set(val) {
        this.$store.commit("menu/set_men_icon", val);
      },
    },
    men_isadmin: {
      get() {
        return this.$store.state.menu.menuIsAdmin || null;
      },
      set(val) {
        val = val == true ? 1 : 0;
        this.$store.commit("menu/set_men_isadmin", val);
      },
    },
    men_parent: {
      get() {
        return this.$store.state.menu.menuParent || 0;
      },
      set(val) {
        this.$store.commit("menu/set_men_parent", val);
      },
    },
    men_status: {
      get() {
        return this.$store.state.menu.menuStatus || null;
      },
      set(val) {
        val = val == true ? 1 : 0;
        this.$store.commit("menu/set_men_status", val);
      },
    },
  },

  methods: {
    go_back() {
      let display = {
        table: true,
        add: false,
        edit: false,
      };
      this.$emit("screen", display);
    },
    saveform() {
      this.$formulate.submit("dataform");
    },
    async formHandler() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45,
      });
      try {
        await this.$store.dispatch("menu/setMenu", this.$store.state.menu);
        this.$vs.notify({
          title: "Success",
          text: "Guardado",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        let display = {
          table: true,
          add: false,
          edit: false,
        };
        this.$emit("screen", display);
      } catch (error) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
      }
    },
  },
};
</script>
<style>
